import React from 'react';
import { RefinementListConnectorParams } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useRefinementList } from 'react-instantsearch';

import { Checkbox } from '../../../checkbox/Checkbox';
import { useEventListContext } from '../context/EventListProvider';

type CheckboxGroupProps = RefinementListConnectorParams & { label: string };

const CheckboxGroup = (props: CheckboxGroupProps) => {
  const { i18n } = useEventListContext();

  const { items, refine, canToggleShowMore, isShowingMore, toggleShowMore } =
    useRefinementList(props);

  if (items.length === 0) return null;

  return (
    <div className="event-list__facet event-list__facet--checkbox-group">
      <p className="typo-copy font-bold">{props.label}</p>

      <div className="event-list__checkbox-group">
        {items.map((i, index) => (
          <Checkbox
            onChange={() => refine(i.value)}
            id={`${props.attribute}-${index}`}
            name={props.attribute}
            value={i.value}
            label={i.label}
            count={i.count}
            checked={i.isRefined}
            key={i.value}
          />
        ))}

        {canToggleShowMore && (
          <button
            type="button"
            onClick={toggleShowMore}
            className="event-list__checkbox-group-toggle"
            data-is-showing-more={isShowingMore}
          >
            <svg
              width="32"
              height="31"
              viewBox="0 0 32 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.33594 11.9475L16.0859 21.9475L23.8359 11.9475H8.33594Z"
                fill="currentColor"
              />
            </svg>

            <span className="typo-copy-small font-medium">
              {isShowingMore ? i18n.showLess : i18n.showMore}
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

export default CheckboxGroup;
